import { message } from "antd";
export class MessagesService {
  static success(text = "success") {
    message.success(text);
  }
  static error(text = "error") {
    message.error(text);
  }

  static axiosError(err: any, text = "") {
    if (err?.data?.errors) {
      const first = Object.entries(err.data.errors)[0];
      this.error(`${first[0]}: ${first[1]}`);
    } else {
      this.error(err?.message || text);
    }
  }
}
